import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { modalError } from '../../../Component/Modal/ModalLayout';
import { apiCall } from '../../../API/RestApi';

export const exportStockOutExcel = async (token, startDate, endDate) => {
    const formattedStart = startDate.format('YYYY-MM-DD');
    const formattedEnd = endDate.format('YYYY-MM-DD');

    try {
        const res = await apiCall({
            method: 'GET',
            url: `/outletstock?startDate=${formattedStart}&endDate=${formattedEnd}`,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        });

        if (res.status === 200) {
            const data = res.data.rows || [];
            let rows = [];
            let no = 1;

            data.forEach((outlet) => {
                outlet.outlet_stocks.forEach((stock) => {
                    const variantName = stock.variant_product?.SKU || '-';
                    const stockNow = stock.stock;
                    const stockOuts = stock.outlet_stock_outs.length
                        ? stock.outlet_stock_outs
                        : [{ stock_out: 0, date: '-' }];

                    stockOuts.forEach((out) => {
                        rows.push({
                            No: no++,
                            'Nama Outlet': outlet.outlet_name,
                            'Produk Variant': variantName,
                            'Stok Sekarang': stockNow,
                            'Stok Keluar': out.stock_out,
                            'Tanggal Stok Keluar': out.date,
                        });
                    });
                });
            });

            const ws = XLSX.utils.json_to_sheet([]);

            // Tambah judul & periode
            XLSX.utils.sheet_add_aoa(ws, [
                ['Laporan Stok Keluar'],
                [`Periode: ${formattedStart} s/d ${formattedEnd}`],
            ], { origin: 'A1' });

            // Tambah data mulai dari A4
            XLSX.utils.sheet_add_json(ws, rows, {
                origin: 'A4',
                skipHeader: false,
            });

            const headerKeys = Object.keys(rows[0] || {});

            // Merge judul & periode
            ws['!merges'] = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: headerKeys.length - 1 } },
                { s: { r: 1, c: 0 }, e: { r: 1, c: headerKeys.length - 1 } },
            ];

            // Styling untuk sel judul dan periode
            ws['A1'].s = {
                font: { bold: true, sz: 14 },
                alignment: { horizontal: 'center' },
            };
            ws['A2'].s = {
                font: { italic: true },
                alignment: { horizontal: 'center' },
            };

            // Styling header (baris ke-4)
            headerKeys.forEach((key, i) => {
                const cell = XLSX.utils.encode_cell({ r: 3, c: i });
                if (!ws[cell]) return;
                ws[cell].s = {
                    font: { bold: true },
                    fill: {
                        patternType: 'solid',
                        fgColor: { rgb: 'D9E1F2' }, // Biru muda
                    },
                    border: {
                        top: { style: 'thin', color: { rgb: '000000' } },
                        bottom: { style: 'thin', color: { rgb: '000000' } },
                        left: { style: 'thin', color: { rgb: '000000' } },
                        right: { style: 'thin', color: { rgb: '000000' } },
                    },
                    alignment: { horizontal: 'center', vertical: 'center' },
                };
            });

            // Border & alignment untuk semua data
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let R = 4; R <= range.e.r; ++R) {
                for (let C = 0; C <= range.e.c; ++C) {
                    const cellAddr = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!ws[cellAddr]) continue;
                    ws[cellAddr].s = {
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } },
                        },
                        alignment: { horizontal: 'left', vertical: 'center', wrapText: true },
                    };
                }
            }

            // Lebar kolom otomatis
            ws['!cols'] = headerKeys.map((key) => {
                const headerWidth = key.length;
                const maxCellWidth = rows.reduce((max, row) => {
                    const val = row[key] || '';
                    return Math.max(max, val.toString().length);
                }, headerWidth);
                return { wch: maxCellWidth + 2 };
            });

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Stok Keluar');

            const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Stok_Keluar_${formattedStart}_to_${formattedEnd}.xlsx`);
        } else {
            modalError('Gagal mengambil data stok keluar');
        }
    } catch (err) {
        modalError('Terjadi kesalahan saat export');
    }
};

export const handleDownloadTemplate = () => {
  const templateData = [
    {
      'Kode Outlet': 'C.01820',
      'Nama Outlet': 'BOLDe STORE Karawang Festive Walk',
      'SKU': 'BOLDe Super MOP ATHENA STAINLESS',
      'Stok Sekarang': 100,
    },
  ];

  const worksheet = XLSX.utils.json_to_sheet(templateData);

  // Define headers in exact order
  const headers = ['Kode Outlet', 'Nama Outlet', 'SKU', 'Stok Sekarang'];

  // Apply header styles
  const headerStyle = {
    font: { bold: true, color: { rgb: '000000' } },
    alignment: { horizontal: 'center' },
    fill: { fgColor: { rgb: 'D9D9D9' } },
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  const cellStyle = {
    alignment: { horizontal: 'left' },
    border: {
      top: { style: 'thin', color: { rgb: '999999' } },
      bottom: { style: 'thin', color: { rgb: '999999' } },
      left: { style: 'thin', color: { rgb: '999999' } },
      right: { style: 'thin', color: { rgb: '999999' } },
    },
  };

  // Apply header styles
  headers.forEach((header, i) => {
    const col = String.fromCharCode(65 + i) + '1'; // A1, B1, C1, D1
    if (worksheet[col]) worksheet[col].s = headerStyle;
  });

  // Apply cell style to data rows
  for (let row = 2; row <= templateData.length + 1; row++) {
    for (let col = 0; col < headers.length; col++) {
      const cellRef = String.fromCharCode(65 + col) + row;
      if (worksheet[cellRef]) worksheet[cellRef].s = cellStyle;
    }
  }

  // Set column widths
  worksheet['!cols'] = [
    { wch: 15 }, // Kode Outlet
    { wch: 40 }, // Nama Outlet
    { wch: 35 }, // SKU
    { wch: 15 }, // Stok Sekarang
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  saveAs(blob, 'Template_Import_OutletStock.xlsx');
};
